import { Collapse } from 'antd';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function N() {
    const { useLang, Link, useRouter } = useGlobal();
    const { t } = useLang('powerbackup');
    const { locale } = useRouter();
    const lists: any = [
        {
            title: t('secN_q1'),
            desc: t.rich('secN_a1', {
                a1: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/pages/portable-power-stations`} className="a-link">
                        {text}
                    </Link>
                ),
                a2: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/pages/solar-generators`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secN_q2'),
            desc: t.rich('secN_a2', {
                a1: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/pages/whole-home-generator`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secN_q3'),
            desc: t('secN_a3'),
        },
        {
            title: t('secN_q4'),
            desc: t.rich('secN_a4', {
                a1: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/collections/river-series`} className="a-link">
                        {text}
                    </Link>
                ),
                a2: (text: string) => (
                    <Link href={`https://${locale}.ecoflow.com/collections/delta-series`} className="a-link">
                        {text}
                    </Link>
                ),
            }),
        },
        {
            title: t('secN_q5'),
            desc: t('secN_a5'),
        },
        {
            title: t('secN_q6'),
            desc: t('secN_a6'),
        },
        {
            title: t('secN_q7'),
            desc: t('secN_a7'),
        },
        {
            title: t('secN_q8'),
            desc: t('secN_a8'),
        },
    ];
    return (
        <div id="power-backup-N" className={`power-backup-N ef-layer ${css['power-backup-N']}`}>
            <div className="text-box">
                <p className="title">{t('secN_title')}</p>
            </div>
            <Collapse
                ghost={true}
                className="collapse-lists"
                defaultActiveKey={0}
                // onChange={setActive}
                // accordion={true}
                expandIcon={({ isActive }: any) => {
                    return (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    );
                }}
                expandIconPosition="right"
            >
                {lists?.map((list: any, k: number) => (
                    <Collapse.Panel className="list-title" key={k} header={list.title}>
                        <p className="list-desc">{list.desc}</p>
                    </Collapse.Panel>
                ))}
            </Collapse>
        </div>
    );
}
